import http from "./http";

// GET ALL LEAGUES
export const getLeagues = async () => {
  const res = await http.get("create_league");
  return res.data;
};

// ADD LEAGUE
export const addLeague = async (league_name) => {
  const res = await http.post("create_league", {
    action: "add",
    league_name,
  });
  return res.data;
};

// UPDATE LEAGUE
export const updateLeague = async (id, league_name) => {
  const res = await http.post("create_league", {
    action: "edit",
    id,
    league_name,
  });
  return res.data;
};

// DELETE LEAGUE
export const deleteLeague = async (id) => {
  const res = await http.post("create_league", {
    action: "delete",
    id,
  });
  return res.data;
};



// import http from "./http";

// /* ================= GET ALL LEAGUES ================= */
// export const getLeagues = async () => {
//   try {
//     const res = await http.get("get_leagues");

//     if (res.data?.status === true && Array.isArray(res.data.data)) {
//       return {
//         status: true,
//         data: res.data.data.map((item) => ({
//           id: item.id,
//           league_name: item.name,
//           image_path: item.image_path, // ✅ image added
//         })),
//       };
//     }

//     return { status: false, data: [] };
//   } catch (error) {
//     console.error("Get leagues error:", error);
//     return { status: false, data: [] };
//   }
// };

// /* ================= ADD LEAGUE ================= */
// export const addLeague = async (league_name) => {
//   const res = await http.post("create_league", {
//     action: "add",
//     league_name,
//   });
//   return res.data;
// };

// /* ================= UPDATE LEAGUE ================= */
// export const updateLeague = async (id, league_name) => {
//   const res = await http.post("create_league", {
//     action: "edit",
//     id,
//     league_name,
//   });
//   return res.data;
// };

// /* ================= DELETE LEAGUE ================= */
// export const deleteLeague = async (id) => {
//   const res = await http.post("create_league", {
//     action: "delete",
//     id,
//   });
//   return res.data;
// };
